export default [
    {
        path: '*',
        meta: {
          public: true,
        },
        redirect: {
          path: '/404'
        }
    },  
    {
        path: '/404',
        meta: {
          public: true,
        },
        name: '404',
        component: ()=>import('@/components/page/NotFound')
    },
    {
        path: '/deny',
        meta: {
          public: true,
        },
        name: 'deny',
        component: ()=>import('@/components/page/Deny')
    },
];